import * as React from 'react';

import Pencil16 from './Pencil16';

export const pencil16 = () => <Pencil16 />;

export default {
    title: 'Icon/Line/Pencil16',
    component: Pencil16,
    parameters: {
        notes: "`import Pencil16 from 'box-ui-elements/es/icon/line/Pencil16';`",
    },
};
